module.exports = __webpack_public_path__ + "app-static/img/contract-bg.09ebfbe4.png";